import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix, MatOption } from '@angular/material/select';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-rental-ev-credits-popup',
    templateUrl: './rental-ev-credits-popup.component.html',
    styleUrls: ['./rental-ev-credits-popup.component.scss'],
    imports: [MatIcon, MatSuffix, NgIf, NgFor, MatOption, MatButton, NgClass, TranslatePipe]
})
export class RentalEvCreditsPopupComponent implements OnInit {

  public values = ['01', '02', '03', '04', '05', '06', '07'];
  public selectedCreditLimit = "01";
  public enableCreditLimitOptions = false;

  constructor(public dialogRef: MatDialogRef<RentalEvCreditsPopupComponent>) { }

  /**
   * @function close will close the Modal
   */
  public close(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

   /**
   * @function setSelectedValue to set the selected value
   */

  setSelectedValue(value) {
    this.selectedCreditLimit = value;
    this.enableCreditLimitOptions = false;
  }

  public confirm(): void{
    this.dialogRef.close(this.selectedCreditLimit);
  }

}




